<div class="manage_business">
        <div class="header_body">
            <div class="header_1">
                <div class="header_details">
                    <div
                        style="font-size: 20px;font-family: var(--font);letter-spacing: 1px;word-spacing: 1px;font-weight: 500;color: black;">
                        Manage Business
                    </div>
                    <div style="font-size: 26px;font-family: var(--font);padding: 20px 0px;letter-spacing: 1px;word-spacing: 1px;color:#505050;font-weight: 500;">
                        Business
                    </div>
                </div>
                <div class="new_brand_button">
                    <button class="add_new_business_btn" (click)="openBrandModal()"><mat-icon style="margin-right: 5px;">add</mat-icon>
                        <div style="margin-top: 4px;">BUSINESS</div></button>
                </div>
            </div>
        </div>
        <div style="margin: 25px 0px;color: black;letter-spacing: 1px;font-family: var(--font);font-size: 18px;">
            Add and manage your Business from here.
        </div>
        <div *ngIf="!dataSource || dataSource.data.length === 0" class="no-data" style="text-align: center;">
            <img src="assets/svg/business.svg" alt="No accounts to display" class="business_image">
            <p style="font-family: var(--font);color: grey; font-size: 50px; text-align: center;padding: 10px 0px;line-height: 1;">Create Business to display</p>
        </div>
        <div *ngIf="dataSource.data.length > 0" class="manage_business_table">
            <table mat-table [dataSource]="dataSource" class="" style="border-radius: 10px;">
                <ng-container matColumnDef="BusinessInfo_BusinessName">
                    <th mat-header-cell *matHeaderCellDef> Business Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.BusinessInfo_BusinessName}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="BusinessInfo_BusinessType">
                    <th mat-header-cell *matHeaderCellDef> Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.BusinessInfo_BusinessType}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="Created_On">
                    <th mat-header-cell *matHeaderCellDef> Added On </th>
                    <td mat-cell *matCellDef="let element"> {{element.Created_On}} </td>
                </ng-container>

                <!-- Symbol Column -->

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element; let i = index" style="text-align: center;">
                        <div class="action-container" style="display: flex; justify-content: right; ">
                            <mat-icon class="material-symbols-outlined action_buttons"
                                (click)="ViewDetails(element.BusinessInfoId)">view_timeline</mat-icon>
                            <mat-icon *ngIf="element.BusinessInfoId != CheckBusinessInfoId"
                                class="material-symbols-outlined action_buttons" (click)="Switch(element.BusinessInfoId , element.BusinessInfo_BusinessName , i)">repeat</mat-icon>
                            <mat-icon class="material-symbols-outlined action_buttons" style="color: red;"
                                (click)="DeleteButton(element.BusinessInfo_BusinessName,element.BusinessInfoId)">delete</mat-icon>
                            <mat-icon class="material-symbols-outlined action_buttons"
                                (click)="Settings(element.BusinessInfoId)">settings</mat-icon>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
</div>